export default "__VITE_ASSET__ea71769e__"